import { render, staticRenderFns } from "./ButtonToTop.vue?vue&type=template&id=c1489920&scoped=true&"
import script from "./ButtonToTop.vue?vue&type=script&lang=js&"
export * from "./ButtonToTop.vue?vue&type=script&lang=js&"
import style0 from "./ButtonToTop.vue?vue&type=style&index=0&id=c1489920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1489920",
  null
  
)

export default component.exports